import { useMemo } from 'react';
import { buildFileListProjection } from '../components/FileQueue/fileListProjectionUtils';
import {
  normalizeFileListFilters,
  normalizeFileListSort,
} from '../config/fileListView';

export function useFileListProjection({ files, sort, filters }) {
  const normalizedSort = useMemo(() => normalizeFileListSort(sort), [sort]);
  const normalizedFilters = useMemo(
    () => normalizeFileListFilters(filters),
    [filters],
  );

  return useMemo(
    () =>
      buildFileListProjection(files, normalizedSort, normalizedFilters),
    [files, normalizedSort, normalizedFilters],
  );
}

export default useFileListProjection;
